import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';

import FileUploadField from '../../FileUploadField';

import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const AddNewTemplateAppointmentAMAgreement = ({ closeModal, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [files, setFiles] = React.useState({
        template_consent: null,
    });
    const [isResetPdConsents, setIsResetPdConsents] = React.useState(false);

    const [loading, setLoading] = React.useState(false);
    const [status, setStatus] = React.useState('');

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!files.template_consent) {
            newErrors.file = 'Прикрепите файл';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
            ...prev,
            [field]: file || null,
        }));
    };

    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
            ...prev,
            [field]: null,
        }));
    };

    const addData = () => {
        const token = localStorage.getItem('token');

        setStatus(<a><Loading type='inline' /></a>);
        
        const formData = new FormData();

        if (files.template_consent) {
            formData.append('file_template_consent', files.template_consent);
        }

        axios.put('/api/upload-template-appointment-am-agreement', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setStatus(<a>Шаблон согласия отправлен</a>);
            openTimeModal('Шаблон согласия отправлен', 'success');
            onSuccess();
            
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>{`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`}</a>);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            addData();
        }
        setLoading(false);
    }


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Добавление нового шаблона согласия управляющего на назначение</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <WarningPanel text={<>При подготовке шаблона согласия на назначение необходимо использовать специальные теги, чтобы система автоматически подставляла нужные данные.<br/> Все теги вставляются в документ в формате [[Тег]] (двойные квадратные скобки без пробелов).<br/><br/> Обязательно укажите следующие теги:<br/> [[ФИО]] — на его место будет подставлено полное имя пользователя (фамилия, имя и отчество);<br/> [[Суд]] — сюда автоматически подставляется название суда, при этом система сама добавляет слова «Арбитражный суд»;<br/> [[Должник]] — подставляется наименование/ФИО должника;<br/> [[ДолжникАдрес]] — почтовый адрес должника;<br/> [[дд]], [[мм]], [[гг]] — текущая дата, соответственно день, месяц и год в двухзначном формате.<br/> [[%Подпись]] — в этом месте появится изображение электронной подписи пользователя. Перед загрузкой убедитесь, что документ сохранён в формате .docx и что все теги написаны точно в указанном виде.</>} />
                    <div className='labelInputWrapper'>
                        <a className='label'>Новый файл шаблона</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <FileUploadField
                                    label='Прикрепить новый шаблон'
                                    file={files.template_consent}
                                    buttonLabel='Прикрепить новый шаблон'
                                    onChange={handleFileChange('template_consent')}
                                    onReset={handleFileReset('template_consent')}
                                    allowedFileTypes={['docx']}
                                />
                                {errorsForm.file && <div className='errorUnderInput'>{errorsForm.file}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        Добавить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddNewTemplateAppointmentAMAgreement;
